import { Component, Injector, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { filter, map, Observable, takeUntil } from 'rxjs';

import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MenuModule } from 'primeng/menu';

import { BaseUnsubscribe } from './core/base-class/base-unsubscribe';
import { LoaderService } from './core/services/loader.service';
import { KeycloakService } from './core/keycloak/keycloak.service';

import { SidebarComponent } from './shared/components/sidebar/sidebar';
import { MenuItem } from 'primeng/api';
import { BreadcrumbService } from './core/services/breadgrumbs.service';
@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    SidebarComponent,
    ProgressSpinnerModule,
    ToastModule,
    ButtonModule,
    BreadcrumbModule,
    MenuModule,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class AppComponent extends BaseUnsubscribe {
  pageTitle = '';
  protected readonly title = signal('cymonz');

  readonly items$: Observable<MenuItem[]>;
  readonly profileMenuItems: MenuItem[] = [
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => this.logout(),
    },
  ];

  constructor(
    injector: Injector,
    private router: Router,
    private route: ActivatedRoute,
    public readonly loaderService: LoaderService,
    private readonly keycloakService: KeycloakService,
    private readonly breadcrumbService: BreadcrumbService,
  ) {
    super(injector);

    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationStart),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(() => {
        queueMicrotask(() => this.breadcrumbService.clearBreadcrumbs());
      });

    this.items$ = this.breadcrumbService.breadcrumbs$.pipe(
      map((items) => {
        const mapped = items.map((b) => ({ label: b.label, routerLink: b.routerLink }));
        if (mapped.length) {
          const last = mapped[mapped.length - 1];
          mapped[mapped.length - 1] = { ...last, routerLink: undefined };
        }
        return mapped;
      }),
    );

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let child = this.route.firstChild;
          while (child?.firstChild) {
            child = child.firstChild;
          }
          return child?.snapshot.data?.['title'] || '';
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe((title: string) => {
        this.pageTitle = title;
      });
  }

  logout() {
    this.keycloakService.logout();
  }
}
